import { Button, Card, Flex, Progress, TableColumnsType, Tag } from "antd";
import {
  FilterIcon,
  PlusIcon,
  SelectArrow,
} from "../../../../../../atoms/CustomIcons";
import TableUi from "../../../../../../atoms/Table";
import { useState } from "react";

export default function TabScopePricing() {
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const statusClassMap: Record<string, string> = {
    "in progress": "approval_pending_tag",
    accepted: "accepted_tag",
    declined: "declined_red_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Name",
      dataIndex: "name",
      width: 270,
      render: (text, record) => {
        const isLastRow = record.key === "4";
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {text ? text : "-"}
            {isLastRow && (
              <img
                src="/images/potential-deals/proposal_document_yellow.svg"
                alt="icon"
                style={{ width: 23, height: 23 }}
              />
            )}
          </span>
        );
      },
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      fixed: "left",
    },
    {
      title: "Change delta",
      dataIndex: "change_delta",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.change_delta?.localeCompare(b?.change_delta),
      fixed: "left",
    },
    {
      title: "Resulted amount",
      dataIndex: "resulted_amount",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.resulted_amount?.localeCompare(b?.resulted_amount),
    },
    {
      title: "Gross margin",
      dataIndex: "gross_margin",
      width: 150,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.gross_margin?.localeCompare(b?.gross_margin),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render: (text) => {
        const cls = statusClassMap[text?.toLowerCase()] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {text}
          </Tag>
        );
      },

      sorter: (a, b) => a?.status?.localeCompare(b?.status),
    },
  ];

  const dummyArray = [
    {
      key: "1",
      name: "Change order - 07.21.2025",
      change_delta: "+$5,708",
      resulted_amount: "$551,508",
      gross_margin: "48%",
      status: "In progress",
    },
    {
      key: "2",
      name: "Change order - 07.20.2025",
      change_delta: "-$1,246",
      resulted_amount: "$544,554",
      gross_margin: "46%",
      status: "In progress",
    },
    {
      key: "3",
      name: "Change order - 06.12.2025",
      change_delta: "+$22,108",
      resulted_amount: "$545,800",
      gross_margin: "45%",
      status: "Accepted",
    },
    {
      key: "4",
      name: "Change order - 05.07.2025",
      change_delta: "+$47,987",
      resulted_amount: "$571,679",
      gross_margin: "46%",
      status: "Declined",
    },
  ];

  return (
    <div className="dashboard-tab">
      <div className="scope_n_pricing" style={{ marginBottom: "16px" }}>
        <h4>
          Current scope of work
          <div style={{ backgroundColor: "#FFF1A6", borderRadius: "100px" }}>
            <img
              src="/images/potential-deals/proposal_document_yellow.svg"
              alt=""
            />
          </div>
        </h4>
        <p style={{ fontSize: "12px", marginBottom: "12px" }}>
          Latest accepted - 03.06.2025
        </p>
        <div className="widgets">
          <Card style={{ width: "40%" }}>
            <h6> Estimate </h6>
            <Flex gap="small" vertical style={{ marginBottom: "12px" }}>
              <Progress strokeColor="#00A07D" percent={55} showInfo={false} />
            </Flex>
            <div
              style={{
                marginBottom: "2px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "space-between",
              }}
            >
              <span>Gross margin:</span>
              <span style={{ fontSize: "16px", fontWeight: 700 }}>45%</span>
            </div>
            <div
              style={{
                marginBottom: "2px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                justifyContent: "space-between",
              }}
            >
              <span>Total amount:</span>
              <span style={{ fontSize: "16px", fontWeight: 700 }}>
                $545,800
              </span>
            </div>
          </Card>
          <Card style={{ width: "20%" }}>
            <img
              src="/images/potential-deals/proposal_document.svg"
              alt=""
              style={{ marginBottom: "12px" }}
            />
            <h6 style={{ marginBottom: "8px" }}> Proposal document </h6>
            <p style={{ color: "#474C4D", fontSize: "12px" }}>
              Client offer doc
            </p>
          </Card>
          <Card style={{ width: "40%" }}>
            <img
              src="/images/potential-deals/status/inprogress.svg"
              alt=""
              style={{ marginBottom: "12px" }}
            />
            <h6 style={{ marginBottom: "8px" }}> Work in production </h6>
            <p style={{ color: "#474C4D", fontSize: "12px" }}>
              This scope of work is currently in progress.
            </p>
          </Card>
        </div>
      </div>
      <div>
        <Card className="scope_n_pricing table_area_scope bold_table noOverflow">
          <div className="header">
            <h3> Change orders </h3>
            <div style={{ display: "flex", gap: "8px" }}>
              <div className="filterToggle">
                <Button
                  icon={<FilterIcon />}
                  className="outlined-btn"
                  onClick={() => console.log("Toggle filters")}
                >
                  Filters
                  <div className="filter_icon">
                    <SelectArrow />
                  </div>
                </Button>
              </div>
              <div className="filterDownload">
                <Button className="outlined-btn">
                  <PlusIcon /> Change order{" "}
                </Button>
              </div>
            </div>
          </div>

          <TableUi
            columns={columns}
            data={{
              count: dummyArray?.length,
              data: dummyArray || [],
            }}
            pageSize={limit}
            setPageSize={setLimit}
            setCurrentPage={setPagination}
            currentPage={pagination}
            selectedRowKeys={selectedRowKeys}
            setSelectedRowKeys={setSelectedRowKeys}
          />
        </Card>
      </div>
    </div>
  );
}
